import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from "../../axios/axiosconf";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import Swal from 'sweetalert2';

function ConfiguracionRDA() {
    const [loading, setLoading] = useState(false);
    const [testing, setTesting] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [client, setClient] = useState([]);

    const [repsCode, setRepsCode] = useState('');
    const [clientId, setClientId] = useState('');
    const [clientSecret, setClientSecret] = useState('');
    const [env, setEnv] = useState('sandbox');
    
    const [errorlist, setErrorlist] = useState({});
    const [logs, setLogs] = useState([]);

    let history = useHistory();

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));
        let permisosList = [];
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permisosList = userdata.permissions.map((p) => p.slug);
        } else if (userdata.up) {
            permisosList = userdata.up;
        }

        if (!permisosList.includes('administrarPersonalProveedores')) {
            setHasPermission(false);
            return;
        }

        setHasPermission(true);

        // Cargar información del cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log(error));

        // Cargar configuración actual
        axios.get('/interop-config')
            .then(response => {
                if (response.data) {
                    setRepsCode(response.data.reps_code || '');
                    setClientId(response.data.hercules_client_id || '');
                    setEnv(response.data.env || 'sandbox');
                    // El secret no se carga por seguridad (viene como ********)
                }
            })
            .catch(error => console.log(error));

        // Cargar logs
        fetchLogs();
    }, []);

    const fetchLogs = () => {
        axios.get('/interop-logs')
            .then(response => {
                setLogs(response.data || []);
            })
            .catch(error => console.log(error));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const data = {
            reps_code: repsCode,
            hercules_client_id: clientId,
            hercules_client_secret: clientSecret,
            env: env
        };

        axios.post('/interop-config', data)
            .then(response => {
                setLoading(false);
                Swal.fire({
                    icon: 'success',
                    title: '¡Éxito!',
                    text: 'Configuración RDA guardada correctamente.',
                    confirmButtonColor: '#17a2b8'
                });
            })
            .catch(err => {
                setLoading(false);
                if (err.response && err.response.data.errors) {
                    setErrorlist(err.response.data.errors);
                }
            });
    };

    const handleTestConnection = () => {
        setTesting(true);
        axios.post('/interop-test-connection')
            .then(response => {
                setTesting(false);
                Swal.fire({
                    icon: 'success',
                    title: 'Conexión Exitosa',
                    text: response.data.message,
                    confirmButtonColor: '#17a2b8'
                });
                fetchLogs();
            })
            .catch(err => {
                setTesting(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Error de Conexión',
                    text: err.response ? err.response.data.message : 'No se pudo conectar con el servidor.',
                    confirmButtonColor: '#17a2b8'
                });
                fetchLogs();
            });
    };

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (hasPermission !== true || !loggedIn) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="settings" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item active">Interoperabilidad RDA</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <h1 className="m-0" style={{ color: '#323a45', fontWeight: '700' }}>
                                    <i className="fas fa-exchange-alt mr-2" style={{ color: '#17a2b8' }}></i>
                                    Interoperabilidad RDA (MinSalud)
                                </h1>
                                <p className="text-muted">
                                    Configuración legacy a nivel clínica. El envío RDA usa las credenciales personales de cada usuario en Parámetros RDA.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            {/* Formulario de Configuración */}
                            <div className="col-md-7">
                                <div className="card shadow-sm" style={{ borderRadius: '12px' }}>
                                    <div className="card-header bg-white border-0 pt-4">
                                        <h3 className="card-title" style={{ fontWeight: '600' }}>Credenciales de Hércules V2</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <label className="text-uppercase small font-weight-bold">Código REPS (12 dígitos)</label>
                                                <input 
                                                    type="text" 
                                                    className={`form-control ${errorlist.reps_code ? 'is-invalid' : ''}`}
                                                    placeholder="Ej: 050010000001"
                                                    value={repsCode}
                                                    onChange={(e) => setRepsCode(e.target.value)}
                                                    style={{ borderRadius: '10px' }}
                                                />
                                                <div className="invalid-feedback">{errorlist.reps_code}</div>
                                            </div>

                                            <div className="form-group">
                                                <label className="text-uppercase small font-weight-bold">Client ID (Hércules)</label>
                                                <input 
                                                    type="text" 
                                                    className={`form-control ${errorlist.hercules_client_id ? 'is-invalid' : ''}`}
                                                    value={clientId}
                                                    onChange={(e) => setClientId(e.target.value)}
                                                    style={{ borderRadius: '10px' }}
                                                />
                                                <div className="invalid-feedback">{errorlist.hercules_client_id}</div>
                                            </div>

                                            <div className="form-group">
                                                <label className="text-uppercase small font-weight-bold">Client Secret (Hércules)</label>
                                                <input 
                                                    type="password" 
                                                    className={`form-control ${errorlist.hercules_client_secret ? 'is-invalid' : ''}`}
                                                    placeholder="Ingrese su secreto para actualizar"
                                                    value={clientSecret}
                                                    onChange={(e) => setClientSecret(e.target.value)}
                                                    style={{ borderRadius: '10px' }}
                                                />
                                                <div className="invalid-feedback">{errorlist.hercules_client_secret}</div>
                                            </div>

                                            <div className="form-group">
                                                <label className="text-uppercase small font-weight-bold">Ambiente</label>
                                                <select 
                                                    className="form-control"
                                                    value={env}
                                                    onChange={(e) => setEnv(e.target.value)}
                                                    style={{ borderRadius: '10px' }}
                                                >
                                                    <option value="sandbox">Sandbox (Pruebas)</option>
                                                    <option value="production">Producción</option>
                                                </select>
                                            </div>

                                            <div className="row mt-4">
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-info btn-block py-2" style={{ borderRadius: '10px', fontWeight: '600' }} disabled={loading}>
                                                        {loading ? <span className="spinner-border spinner-border-sm mr-2"></span> : <i className="fas fa-save mr-2"></i>}
                                                        Guardar Configuración
                                                    </button>
                                                </div>
                                                <div className="col-md-6">
                                                    <button type="button" className="btn btn-outline-info btn-block py-2" style={{ borderRadius: '10px', fontWeight: '600' }} onClick={handleTestConnection} disabled={testing}>
                                                        {testing ? <span className="spinner-border spinner-border-sm mr-2"></span> : <i className="fas fa-plug mr-2"></i>}
                                                        Validar Conexión
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/* Panel Informativo / Logs */}
                            <div className="col-md-5">
                                <div className="card shadow-sm" style={{ borderRadius: '12px', background: '#f8f9fa' }}>
                                    <div className="card-body">
                                        <h5 style={{ fontWeight: '700', color: '#17a2b8' }}>Protección Legal y Auditoría</h5>
                                        <p className="small text-muted">
                                            Cada transacción enviada al RDA se registra con el XML exacto y la respuesta del servidor. Esto asegura la trazabilidad legal del contenido clínico ingresado.
                                        </p>
                                        <hr />
                                        <h6 style={{ fontWeight: '600' }}>Últimos Logs</h6>
                                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                            <table className="table table-sm table-borderless">
                                                <thead>
                                                    <tr className="small text-muted border-bottom">
                                                        <th>Fecha</th>
                                                        <th>Acción</th>
                                                        <th>Estado</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="small">
                                                    {logs.length > 0 ? logs.map(log => (
                                                        <tr key={log.id} className="border-bottom">
                                                            <td>{new Date(log.created_at).toLocaleString()}</td>
                                                            <td>{log.action}</td>
                                                            <td>
                                                                <span className={`badge badge-${log.status === 'SUCCESS' ? 'success' : 'danger'}`}>
                                                                    {log.status}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="3" className="text-center py-3">No hay registros aún.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
}

export default ConfiguracionRDA;
